import { Mqtt_Topics_userChanges } from "../Optiscan.Models/Api/Api.js";
import { singleton } from "../fable_modules/fable-library.3.7.12/List.js";
import { Msg } from "./AuthTypes.js";

export function subscribe(uid) {
    return [singleton(Mqtt_Topics_userChanges(uid)), (arg0) => (new Msg(21, arg0))];
}

